define([
    'text!cooperate/component/item-marketing.html',
    'cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 4,
                    projectName: '',
                    contact: '',
                    tel: '',
                    email: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./cooperate/component/item-marketing.js
// module id = 217
// module chunks = 0